export default {
    mp3 : 'mp3',
    mp4 : 'mp4',
    webm : 'webm',
}
